module.exports = __webpack_public_path__ + "img/landing.e3634adb.jpg";